import {
  fontSizeVars,
  lineHeightVars,
  spacingVars,
} from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const breadCrumbContainerClass = style({
  display: 'flex',
  alignItems: 'center',
  marginBottom: spacingVars['3xl'],
  fontSize: fontSizeVars.body.body1,
  lineHeight: lineHeightVars.body.body1,
});

export const breadcrumbBackLinkClass = style({
  marginRight: spacingVars['3xl'],
});
